<div class="calendar-page">
<button
      type="button"
      class="widowed-back-btn"
      (click)="goBack()"
      aria-label="Go back">
      <span class="material-symbols-outlined">arrow_back</span>
    </button>

<h2>
Select Your Event Date
</h2>


<div class="calendar-box">


<div class="calendar-header">


<button 
(click)="previousMonth()"
[disabled]="isPreviousMonthDisabled()">

‹

</button>


<h3>
{{monthName}} {{year}}
</h3>


<button 
(click)="nextMonth()">

›

</button>


</div>





<div class="calendar-grid">


<!-- Week Names -->
<div class="day-name" *ngFor="let day of weekDays">
  {{ day }}
</div>

<!-- Dates -->
<div
  class="date"
  *ngFor="let day of calendarDays"
  [class.empty]="day == null"
  [class.disabled]="day && isDateDisabled(day)"
  (click)="day && selectDate(day)"
>
  {{ day || '' }}
</div>


</div>


</div>


</div>